import PropTypes from "prop-types";
import classnames from "classnames/bind";
import { FEMALE, MALE } from "../../state/modules/layout";
import { focusPrimaryNavigationFor } from "../../globalEventHandler";
import {
  FLOOR_NAV_DATA_TESTID,
  FLOOR_NAV_MEN_FLOOR_ID,
  FLOOR_NAV_WOMEN_FLOOR_ID
} from "./constants";
import styles from "./FloorNavigation.css";

const cx = classnames.bind(styles);

const SmallFloorNavigation = ({
  formatTranslation,
  isMensFloorSelected,
  isWomensFloorSelected,
  setFloor
}) => {
  const setFloorAndFocus = floor => {
    setFloor(floor);
    focusPrimaryNavigationFor(floor);
  };

  const handleWomensFloorClick = () => {
    setFloorAndFocus(FEMALE);
  };

  const handleMensFloorClick = () => {
    setFloorAndFocus(MALE);
  };

  return (
    <ul
      className={cx(styles.container, styles.container__small_and_medium)}
      data-testid={FLOOR_NAV_DATA_TESTID}
      role="tablist"
    >
      <li>
        <button
          aria-label={formatTranslation("header_womens_products_aria_label")}
          aria-selected={isWomensFloorSelected}
          className={cx(styles.button, {
            [styles.selected]: isWomensFloorSelected
          })}
          data-testid={FLOOR_NAV_WOMEN_FLOOR_ID}
          id={FLOOR_NAV_WOMEN_FLOOR_ID}
          onClick={handleWomensFloorClick}
          role="tab"
        >
          {formatTranslation("header_women_floor")}
        </button>
      </li>
      <li>
        <button
          aria-label={formatTranslation("header_mens_products_aria_label")}
          aria-selected={isMensFloorSelected}
          className={cx(styles.button, {
            [styles.selected]: isMensFloorSelected
          })}
          data-testid={FLOOR_NAV_MEN_FLOOR_ID}
          id={FLOOR_NAV_MEN_FLOOR_ID}
          onClick={handleMensFloorClick}
          role="tab"
        >
          {formatTranslation("header_men_floor")}
        </button>
      </li>
    </ul>
  );
};

SmallFloorNavigation.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  isMensFloorSelected: PropTypes.bool.isRequired,
  isWomensFloorSelected: PropTypes.bool.isRequired,
  setFloor: PropTypes.func.isRequired
};

export default SmallFloorNavigation;
